<!-- Displays commercial property and brokerage detail rows inside their detail containers. -->
<template>
	<div class="pt-40 md:pt-50 pb-30 md:pb-40 px-45 md:px-70">
		<h3 :class="headingColor">{{ heading }}</h3>

		<!-- Repeated detail rows preserve the order provided by the parent container. -->
		<ul class="mt-20">
			<li
				v-for="(value, key, index) in items"
				:key="index"
				class="flex justify-between py-15 leading-normal"
				:class="{ 'border-b border-gray50 border-solid' : index !== Object.keys(items).length - 1 }"
			>
				<div class="w-2/5 pt-5 font-secondary font-bold text-xs text-gray400 uppercase tracking-loose">
					{{ key }}
				</div>
				<div class="w-3/5 flex justify-end items-center ml-30 text-gray700 text-right" v-html="value"></div>
			</li>
		</ul>

		<slot>
		</slot>
	</div>
</template>

<script>
export default {
	props: {
		heading: {
			type: String,
			required: true
		},
		headingColor: {
			type: String,
			default: 'text-red500'
		},
		items: {
			type: Object,
			default: () => ({})
		}
	}
};
</script>
